<template>
  <div>
    <div
      class="WebappCardContainer"
      :style="{ '--width': cardWidth }"
      v-show="cardWidth"
    >
      <slot></slot>
    </div>
    <div class="is-small has-text-centered h-panel" v-show="!cardWidth">
      No content to show!
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cardWidth: undefined,
    };
  },
  mounted() {
    this.cardWidth = this.$children[0] && this.$children[0].$attrs.width;
  },
};
</script>

<style scoped lang="scss">
.WebappCardContainer {
  display: grid;
  grid-row-gap: 25px;
  grid-column-gap: 25px;
  justify-content: center;
  grid-template-columns: repeat(auto-fill, var(--width));
  align-items: center;
}
</style>
